import { alpha, type Theme } from '@mui/material/styles'

export { buildFormChromeTokens, useFormChrome, formChromeFromAppTheme, withFormChromePalette } from '../../designer/components/editors/FormEditor/formChromeTheme'
export type { FormChromeTokens } from '../../designer/components/editors/FormEditor/formChromeTheme'

/** 1C-style filled strip for the tabular toolbar (and matching column headers). */
export function tabularToolbarBand(theme: Theme): string {
  return theme.palette.mode === 'dark'
    ? alpha(theme.palette.common.white, 0.08)
    : alpha(theme.palette.common.black, 0.05)
}

/** Full-contrast ink on the tabular header band (beats muted TableHead overrides). */
export function tabularHeaderInk(theme: Theme): string {
  return theme.palette.mode === 'dark'
    ? theme.palette.common.white
    : theme.palette.common.black
}

/**
 * Same type as theme `MuiTableHead` — kept for tabular band cells that
 * also set bgcolor (specificity-safe if a fork still ships micro heads).
 */
export function tabularHeaderTypeSx(theme: Theme) {
  return {
    color: tabularHeaderInk(theme),
    fontSize: 14,
    fontWeight: 800,
    letterSpacing: 'normal' as const,
    textTransform: 'none' as const,
    fontFamily: theme.typography.fontFamily,
  }
}

export const FORM_CHROME_DENSITY = {
  gap: 8,
  buttonHeight: 32,
  toolbarHeight: 36,
  radiusCard: 16,
  pillRadius: 999,
} as const
